// AUTO-GENERATED FROM /contracts/rbac/permission-matrix.json — DO NOT EDIT MANUALLY
export const RBAC_MATRIX_VERSION = '1.0.0';
export const ROLES = [
    'SUPER_ADMIN',
    'ORG_ADMIN',
    'WORKSPACE_MANAGER',
    'CAMPAIGN_EDITOR',
    'COMPLIANCE_OFFICER',
    'VIEWER',
    'PARTNER_API',
];
export const PERMISSION_MATRIX = {
    'organisation:read': {
        capability: 'organisation:read',
        surface: 'FIRESTORE',
        operation: 'read',
        permissions: {
            SUPER_ADMIN: true,
            ORG_ADMIN: true,
            WORKSPACE_MANAGER: true,
            CAMPAIGN_EDITOR: true,
            COMPLIANCE_OFFICER: true,
            VIEWER: true,
            PARTNER_API: false,
        },
    },
    'organisation:create': {
        capability: 'organisation:create',
        surface: 'FIRESTORE',
        operation: 'create',
        permissions: {
            SUPER_ADMIN: true,
            ORG_ADMIN: false,
            WORKSPACE_MANAGER: false,
            CAMPAIGN_EDITOR: false,
            COMPLIANCE_OFFICER: false,
            VIEWER: false,
            PARTNER_API: false,
        },
    },
    'organisation:update': {
        capability: 'organisation:update',
        surface: 'FIRESTORE',
        operation: 'update',
        permissions: {
            SUPER_ADMIN: true,
            ORG_ADMIN: true,
            WORKSPACE_MANAGER: false,
            CAMPAIGN_EDITOR: false,
            COMPLIANCE_OFFICER: false,
            VIEWER: false,
            PARTNER_API: false,
        },
    },
    'organisation:delete': {
        capability: 'organisation:delete',
        surface: 'FIRESTORE',
        operation: 'delete',
        permissions: {
            SUPER_ADMIN: false,
            ORG_ADMIN: false,
            WORKSPACE_MANAGER: false,
            CAMPAIGN_EDITOR: false,
            COMPLIANCE_OFFICER: false,
            VIEWER: false,
            PARTNER_API: false,
        },
    },
    'workspace:read': {
        capability: 'workspace:read',
        surface: 'FIRESTORE',
        operation: 'read',
        permissions: {
            SUPER_ADMIN: true,
            ORG_ADMIN: true,
            WORKSPACE_MANAGER: true,
            CAMPAIGN_EDITOR: true,
            COMPLIANCE_OFFICER: true,
            VIEWER: true,
            PARTNER_API: false,
        },
    },
    'workspace:create': {
        capability: 'workspace:create',
        surface: 'FIRESTORE',
        operation: 'create',
        permissions: {
            SUPER_ADMIN: true,
            ORG_ADMIN: true,
            WORKSPACE_MANAGER: false,
            CAMPAIGN_EDITOR: false,
            COMPLIANCE_OFFICER: false,
            VIEWER: false,
            PARTNER_API: false,
        },
    },
    'workspace:update': {
        capability: 'workspace:update',
        surface: 'FIRESTORE',
        operation: 'update',
        permissions: {
            SUPER_ADMIN: true,
            ORG_ADMIN: true,
            WORKSPACE_MANAGER: false,
            CAMPAIGN_EDITOR: false,
            COMPLIANCE_OFFICER: false,
            VIEWER: false,
            PARTNER_API: false,
        },
    },
    'workspace:delete': {
        capability: 'workspace:delete',
        surface: 'FIRESTORE',
        operation: 'delete',
        permissions: {
            SUPER_ADMIN: false,
            ORG_ADMIN: false,
            WORKSPACE_MANAGER: false,
            CAMPAIGN_EDITOR: false,
            COMPLIANCE_OFFICER: false,
            VIEWER: false,
            PARTNER_API: false,
        },
    },
    'domain:read': {
        capability: 'domain:read',
        surface: 'FIRESTORE',
        operation: 'read',
        permissions: {
            SUPER_ADMIN: true,
            ORG_ADMIN: true,
            WORKSPACE_MANAGER: true,
            CAMPAIGN_EDITOR: true,
            COMPLIANCE_OFFICER: true,
            VIEWER: true,
            PARTNER_API: false,
        },
    },
    'domain:manage': {
        capability: 'domain:manage',
        surface: 'CALLABLE',
        operation: 'invoke',
        permissions: {
            SUPER_ADMIN: true,
            ORG_ADMIN: true,
            WORKSPACE_MANAGER: true,
            CAMPAIGN_EDITOR: false,
            COMPLIANCE_OFFICER: false,
            VIEWER: false,
            PARTNER_API: false,
        },
    },
    'domain:verify': {
        capability: 'domain:verify',
        surface: 'CALLABLE',
        operation: 'invoke',
        permissions: {
            SUPER_ADMIN: true,
            ORG_ADMIN: true,
            WORKSPACE_MANAGER: true,
            CAMPAIGN_EDITOR: false,
            COMPLIANCE_OFFICER: false,
            VIEWER: false,
            PARTNER_API: false,
        },
    },
    'identifier:read': {
        capability: 'identifier:read',
        surface: 'FIRESTORE_AND_API',
        operation: 'read',
        requiredScope: 'identifiers:read',
        permissions: {
            SUPER_ADMIN: true,
            ORG_ADMIN: true,
            WORKSPACE_MANAGER: true,
            CAMPAIGN_EDITOR: true,
            COMPLIANCE_OFFICER: true,
            VIEWER: true,
            PARTNER_API: true,
        },
    },
    'identifier:create_stage_update': {
        capability: 'identifier:create_stage_update',
        surface: 'FIRESTORE_AND_API',
        operation: 'write',
        requiredScope: 'identifiers:write',
        permissions: {
            SUPER_ADMIN: true,
            ORG_ADMIN: true,
            WORKSPACE_MANAGER: true,
            CAMPAIGN_EDITOR: true,
            COMPLIANCE_OFFICER: false,
            VIEWER: false,
            PARTNER_API: true,
        },
    },
    'identifier:direct_delete': {
        capability: 'identifier:direct_delete',
        surface: 'FIRESTORE',
        operation: 'delete',
        permissions: {
            SUPER_ADMIN: false,
            ORG_ADMIN: false,
            WORKSPACE_MANAGER: false,
            CAMPAIGN_EDITOR: false,
            COMPLIANCE_OFFICER: false,
            VIEWER: false,
            PARTNER_API: false,
        },
    },
    'qualifier:read': {
        capability: 'qualifier:read',
        surface: 'FIRESTORE_AND_API',
        operation: 'read',
        requiredScope: 'qualifiers:read',
        permissions: {
            SUPER_ADMIN: true,
            ORG_ADMIN: true,
            WORKSPACE_MANAGER: true,
            CAMPAIGN_EDITOR: true,
            COMPLIANCE_OFFICER: true,
            VIEWER: true,
            PARTNER_API: true,
        },
    },
    'qualifier:create_stage_update': {
        capability: 'qualifier:create_stage_update',
        surface: 'FIRESTORE_AND_API',
        operation: 'write',
        requiredScope: 'qualifiers:write',
        permissions: {
            SUPER_ADMIN: true,
            ORG_ADMIN: true,
            WORKSPACE_MANAGER: true,
            CAMPAIGN_EDITOR: true,
            COMPLIANCE_OFFICER: false,
            VIEWER: false,
            PARTNER_API: true,
        },
    },
    'qualifier:direct_delete': {
        capability: 'qualifier:direct_delete',
        surface: 'FIRESTORE',
        operation: 'delete',
        permissions: {
            SUPER_ADMIN: false,
            ORG_ADMIN: false,
            WORKSPACE_MANAGER: false,
            CAMPAIGN_EDITOR: false,
            COMPLIANCE_OFFICER: false,
            VIEWER: false,
            PARTNER_API: false,
        },
    },
    'recall:activate_deactivate': {
        capability: 'recall:activate_deactivate',
        surface: 'CALLABLE_AND_API',
        operation: 'invoke',
        requiredScope: 'recalls:write',
        permissions: {
            SUPER_ADMIN: true,
            ORG_ADMIN: true,
            WORKSPACE_MANAGER: true,
            CAMPAIGN_EDITOR: false,
            COMPLIANCE_OFFICER: true,
            VIEWER: false,
            PARTNER_API: true,
        },
    },
    'apiClient:read': {
        capability: 'apiClient:read',
        surface: 'FIRESTORE',
        operation: 'read',
        permissions: {
            SUPER_ADMIN: true,
            ORG_ADMIN: true,
            WORKSPACE_MANAGER: false,
            CAMPAIGN_EDITOR: false,
            COMPLIANCE_OFFICER: false,
            VIEWER: false,
            PARTNER_API: false,
        },
    },
    'apiClient:manage_callable': {
        capability: 'apiClient:manage_callable',
        surface: 'CALLABLE',
        operation: 'invoke',
        permissions: {
            SUPER_ADMIN: true,
            ORG_ADMIN: true,
            WORKSPACE_MANAGER: false,
            CAMPAIGN_EDITOR: false,
            COMPLIANCE_OFFICER: false,
            VIEWER: false,
            PARTNER_API: false,
        },
    },
    'membership:read': {
        capability: 'membership:read',
        surface: 'FIRESTORE',
        operation: 'read',
        permissions: {
            SUPER_ADMIN: true,
            ORG_ADMIN: true,
            WORKSPACE_MANAGER: true,
            CAMPAIGN_EDITOR: true,
            COMPLIANCE_OFFICER: true,
            VIEWER: true,
            PARTNER_API: false,
        },
    },
    'membership:manage_callable': {
        capability: 'membership:manage_callable',
        surface: 'CALLABLE',
        operation: 'invoke',
        permissions: {
            SUPER_ADMIN: true,
            ORG_ADMIN: true,
            WORKSPACE_MANAGER: false,
            CAMPAIGN_EDITOR: false,
            COMPLIANCE_OFFICER: false,
            VIEWER: false,
            PARTNER_API: false,
        },
    },
    'auditLog:read': {
        capability: 'auditLog:read',
        surface: 'FIRESTORE',
        operation: 'read',
        permissions: {
            SUPER_ADMIN: true,
            ORG_ADMIN: true,
            WORKSPACE_MANAGER: false,
            CAMPAIGN_EDITOR: false,
            COMPLIANCE_OFFICER: true,
            VIEWER: false,
            PARTNER_API: false,
        },
    },
    'auditLog:direct_write': {
        capability: 'auditLog:direct_write',
        surface: 'FIRESTORE',
        operation: 'write',
        permissions: {
            SUPER_ADMIN: false,
            ORG_ADMIN: false,
            WORKSPACE_MANAGER: false,
            CAMPAIGN_EDITOR: false,
            COMPLIANCE_OFFICER: false,
            VIEWER: false,
            PARTNER_API: false,
        },
    },
    'cache:manual_purge': {
        capability: 'cache:manual_purge',
        surface: 'CALLABLE',
        operation: 'invoke',
        permissions: {
            SUPER_ADMIN: true,
            ORG_ADMIN: true,
            WORKSPACE_MANAGER: true,
            CAMPAIGN_EDITOR: true,
            COMPLIANCE_OFFICER: false,
            VIEWER: false,
            PARTNER_API: false,
        },
    },
    'dsar:manage': {
        capability: 'dsar:manage',
        surface: 'CALLABLE',
        operation: 'invoke',
        permissions: {
            SUPER_ADMIN: true,
            ORG_ADMIN: true,
            WORKSPACE_MANAGER: false,
            CAMPAIGN_EDITOR: false,
            COMPLIANCE_OFFICER: false,
            VIEWER: false,
            PARTNER_API: false,
        },
    },
    'analytics:export': {
        capability: 'analytics:export',
        surface: 'API',
        operation: 'invoke',
        requiredScope: 'analytics:read',
        permissions: {
            SUPER_ADMIN: true,
            ORG_ADMIN: true,
            WORKSPACE_MANAGER: true,
            CAMPAIGN_EDITOR: true,
            COMPLIANCE_OFFICER: true,
            VIEWER: true,
            PARTNER_API: true,
        },
    },
    'myplayer:sync': {
        capability: 'myplayer:sync',
        surface: 'API',
        operation: 'invoke',
        requiredScope: 'myplayer:sync',
        permissions: {
            SUPER_ADMIN: true,
            ORG_ADMIN: true,
            WORKSPACE_MANAGER: true,
            CAMPAIGN_EDITOR: true,
            COMPLIANCE_OFFICER: false,
            VIEWER: false,
            PARTNER_API: true,
        },
    },
};
//# sourceMappingURL=generated.js.map